import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, formatDate, returnSign } from 'helpers/helpers'

function SummaryDebtPaid({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [total, setTotal] = useState(0)

	async function searchWithFilter() {
		var filterUrl = "/report/summary-debt-paid"
		var urlParams = ""

		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data || [])
			setTotal(response.data.total || 0)
		}
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={true} animation={false} centered size="lg"
			onHide={() => setActiveModal(false)}>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('debt_paid')}
					{filterData.start_date && filterData.end_date && filterData.start_date === filterData.end_date &&
						<span className="text-muted fz-14 ms-2">— {formatDate(filterData.start_date)}</span>
					}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex justify-content-end mb-3">
					<h6 className="mb-0">
						<b>{t('total')}:</b>{' '}
						<span className="text-success">{formatMoney(total)}</span>
					</h6>
				</div>

				<div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th style={{ minWidth: '33px' }} className="text-center">#</th>
								<th style={{ width: '30%' }}>{t('client')}</th>
								<th style={{ width: '15%' }}>{t('phone')}</th>
								<th style={{ width: '20%' }}>{t('payment_type')}</th>
								<th style={{ width: '17%' }} className="text-center">{t('date')}</th>
								<th style={{ width: '18%' }} className="text-end">{t('amount')}</th>
							</tr>
						</thead>
						<tbody>
							{data.map((item, index) => (
								<tr key={index}>
									<td className="text-center">{index + 1}</td>
									<td className="td-ellipsis">{item.client_name || '—'}</td>
									<td className="text-nowrap">{item.client_phone || '—'}</td>
									<td className="td-ellipsis">{item.payment_type_name || '—'}</td>
									<td className="text-center text-nowrap">
										{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}
									</td>
									<td className="text-end text-nowrap text-success">
										{formatMoney(item.amount)}
									</td>
								</tr>
							))}
							{data.length === 0 &&
								<tr><td colSpan="6" className="text-center text-muted py-4">{t('list_empty')}</td></tr>
							}
						</tbody>
					</table>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default SummaryDebtPaid
